import { render, staticRenderFns } from "./BookingPostpone.vue?vue&type=template&id=32836ff8"
import script from "./BookingPostpone.vue?vue&type=script&lang=js"
export * from "./BookingPostpone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports